{
  "pt": {
    "task": {
      "actions": {
        "create": "Tarefa",
        "create_and_send": "Criar e enviar",
        "delete": "Eliminar tarefa",
        "keep_as_draft": "Manter como rascunho",
        "open_in_project": "Abrir a tarefa no projeto",
        "remove_from_unit": "Remover a tarefa desta unidade",
        "save_as_draft": "Guardar como rascunho",
        "update": "Editar tarefa"
      },
      "attributes": {
        "assignments_count": "Atribuições",
        "category": "Forma de concluir",
        "created_at": "Criado em",
        "description": "Descrição",
        "phase": "Fase",
        "title": "Título"
      },
      "categories": {
        "confirmation": "Confirmação",
        "upload": "Carregamento de documento"
      },
      "categories_info": {
        "confirmation": "O responsável marca-a quando estiver feita.",
        "upload": "O responsável tem de carregar um ficheiro para a concluir."
      },
      "confirm": {
        "delete_accept": "Eliminar em todo o lado",
        "delete_body": "Isto elimina {count} tarefa em {units}, mesmo que já esteja concluída. | Isto elimina todas as {count} tarefas em {units}, incluindo as já concluídas.",
        "delete_body_empty": "Isto elimina a tarefa.",
        "delete_body_project": "Isto elimina a tarefa e o seu responsável. | Isto elimina a tarefa e todos os seus {count} responsáveis.",
        "delete_cancel": "Manter a tarefa",
        "delete_header": "Eliminar «{title}»?",
        "delete_silent": "Ninguém é notificado, e as notificações já enviadas não são retiradas.",
        "publish_body": "Criamos {tasks} em {units} e enviamo-las aos respetivos responsáveis. Cada tarefa fica em Aberto até ser concluída.",
        "publish_body_project": "Criamos {tasks} neste projeto e enviamo-las aos respetivos responsáveis. Cada tarefa fica em Aberto até ser concluída.",
        "publish_header": "Criar e enviar esta tarefa?",
        "publish_info": "Os responsáveis recebem logo um email. Guarda-a como rascunho se ainda não estiveres pronto para a enviar.",
        "remove_from_unit_accept": "Remover da unidade",
        "remove_from_unit_body": "Isto remove todos os responsáveis desta tarefa nesta unidade. A tarefa e as suas outras unidades ficam intactas.",
        "remove_from_unit_customers": "Os clientes desta unidade deixam de a ver no seu portal.",
        "remove_from_unit_header": "Remover «{title}» desta unidade?"
      },
      "deep_link": {
        "show_all": "Mostrar todas as tarefas",
        "single": "Está a ver uma tarefa."
      },
      "empty": {
        "filtered_description": "Nada encontrado com os filtros que escolheste. Limpa-os para veres todas as tarefas.",
        "filtered_description_project": "Nada encontrado com os filtros que escolheste. Limpa-os para veres todas as tarefas deste projeto.",
        "filtered_title": "Nenhuma tarefa corresponde aos teus filtros",
        "none_description": "Cria uma tarefa e atribui-a à tua equipa ou aos clientes de uma ou mais unidades. Aparece aqui assim que a enviares.",
        "none_description_sup": "Cria uma tarefa e atribui-a à tua equipa ou aos teus clientes. Aparece aqui assim que a enviares.",
        "none_title": "Ainda sem tarefas"
      },
      "filters": {
        "phase_none": "Sem fase",
        "search": "Pesquisar tarefa"
      },
      "form": {
        "category_subtitle": "Escolhe como o responsável marca a tarefa como concluída",
        "category_title": "Como é concluída?",
        "description_help": "Visível para todos os que recebem esta tarefa.",
        "description_placeholder": "Adiciona detalhes ou instruções",
        "edit_info_assignments": "Os responsáveis, as unidades e os prazos geres por responsável na lista de tarefas.",
        "edit_info_assignments_project": "Os responsáveis e os prazos geres por responsável na lista de tarefas.",
        "edit_info_fields": "Aqui editas o título e a descrição.",
        "edit_info_fields_phase": "Aqui editas o título, a descrição e a fase.",
        "heading_create": "Nova tarefa",
        "heading_update": "Editar tarefa",
        "phase_help_create": "Liga esta tarefa a uma fase do fluxo de trabalho. A fase só fica concluída quando todas as tarefas dela estiverem terminadas.",
        "phase_help_update": "Cada unidade que chegou à nova fase, ou que já a ultrapassou, vê esta tarefa de imediato. As unidades que ainda lá não chegaram veem-na assim que lá chegarem.",
        "phase_help_update_project": "Se este projeto chegou à nova fase, ou já a ultrapassou, os seus responsáveis veem esta tarefa de imediato. Caso contrário, veem-na assim que o projeto lá chegar.",
        "scope_headline": "{count} tarefa será criada e enviada | {count} tarefas serão criadas e enviadas",
        "scope_project": "{assignees} neste projeto",
        "scope_units": "{units} × {assignees}",
        "title_placeholder": "O que é preciso fazer?",
        "units_selected": "{selected} de {count} unidade selecionada | {selected} de {count} unidades selecionadas",
        "units_title": "Que unidades"
      },
      "labels": {
        "assignees_count": "{count} responsável | {count} responsáveis",
        "created_by": "Criado por {name} · {date}",
        "created_on": "Criado em {date}",
        "required": "Este campo é obrigatório",
        "set_all_assignees": "Definir para o responsável | Definir para os {count} responsáveis",
        "still_to_do": "{count} por fazer",
        "tasks_count": "{count} tarefa | {count} tarefas",
        "units_count": "{count} unidade | {count} unidades",
        "units_required": "Selecione pelo menos uma unidade"
      },
      "toasts": {
        "create": "Tarefa criada",
        "delete": "Tarefa eliminada",
        "remove_from_unit": "Tarefa removida desta unidade",
        "update": "Tarefa atualizada"
      }
    }
  }
}
